import { render, staticRenderFns } from "./DNSInstructions.vue?vue&type=template&id=42b0f75c&scoped=true"
import script from "./DNSInstructions.vue?vue&type=script&lang=js"
export * from "./DNSInstructions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b0f75c",
  null
  
)

export default component.exports